<template>
  <!-- Idioma do Connect: Brasil (portugues) a esquerda, Reino Unido (ingles)
       a direita, no mesmo switch do tema. -->
  <pref-switch
    :on="current.code === 'en'"
    :mini="mini"
    :label="ariaLabel"
    :tooltip="$t('sidebar.switchTo', { language: next.label })"
    @toggle="toggle"
  >
    <template v-slot:off="{ place }">
      <svg class="lang-flag" viewBox="0 0 24 24" focusable="false">
        <defs>
          <clipPath :id="clipId('pt', place)">
            <circle cx="12" cy="12" r="12" />
          </clipPath>
        </defs>
        <g :clip-path="`url(#${clipId('pt', place)})`">
          <rect width="24" height="24" fill="#009b3a" />
          <polygon points="12,3.2 22.6,12 12,20.8 1.4,12" fill="#fedf00" />
          <circle cx="12" cy="12" r="4.9" fill="#002776" />
          <path
            d="M7.3 11.2 C 9.8 10.1, 13.6 10.3, 16.8 12.6"
            stroke="#fff"
            stroke-width="1"
            fill="none"
          />
        </g>
      </svg>
    </template>
    <template v-slot:on="{ place }">
      <!-- Union Jack recortada no centro: no disco cabem as diagonais e a
           cruz, que e o que se reconhece. -->
      <svg class="lang-flag" viewBox="0 0 24 24" focusable="false">
        <defs>
          <clipPath :id="clipId('en', place)">
            <circle cx="12" cy="12" r="12" />
          </clipPath>
        </defs>
        <g :clip-path="`url(#${clipId('en', place)})`">
          <rect width="24" height="24" fill="#012169" />
          <path d="M0 0L24 24M24 0L0 24" stroke="#fff" stroke-width="4.8" />
          <path d="M0 0L24 24M24 0L0 24" stroke="#c8102e" stroke-width="1.6" />
          <path d="M12 0V24M0 12H24" stroke="#fff" stroke-width="6" />
          <path d="M12 0V24M0 12H24" stroke="#c8102e" stroke-width="3.6" />
        </g>
      </svg>
    </template>
  </pref-switch>
</template>

<script>
import PrefSwitch from "@/components/PrefSwitch.vue";
import { setLocale } from "@/plugins/i18n";
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";

// O nome de cada idioma fica no próprio idioma, como de costume em
// seletores: quem não lê português reconhece "English".
const LANGUAGES = [
  { code: "pt", label: "Português" },
  { code: "en", label: "English" },
];

export default {
  name: "LanguageSwitcher",

  components: { PrefSwitch },

  props: {
    mini: { type: Boolean, default: false },
  },

  computed: {
    current() {
      return (
        LANGUAGES.find((item) => item.code === this.$i18n.locale) ||
        LANGUAGES[0]
      );
    },
    next() {
      return LANGUAGES.find((item) => item.code !== this.current.code);
    },
    ariaLabel() {
      return `${this.$t("sidebar.language")}: ${this.current.label}. ${this.$t(
        "sidebar.switchTo",
        { language: this.next.label }
      )}`;
    },
  },

  methods: {
    // Cada bandeira aparece duas vezes (trilho e botao) e o switch pode estar
    // em mais de um lugar: o recorte precisa de id unico.
    clipId(code, place) {
      return `flag-clip-${this._uid}-${code}-${place}`;
    },

    // A tela troca na hora; a escolha vai para o usuario em seguida, para
    // valer nos proximos logins em qualquer aparelho.
    async toggle() {
      const language = this.next.code;
      setLocale(language, this.$vuetify);

      const api =
        this.$store.getters.module === "professor"
          ? pitchPartnerApi
          : pitchCustomerApi;

      try {
        await api.updateLanguage(language);
        this.$store.commit("SET_USER", {
          ...(this.$store.getters.user || {}),
          language,
        });
      } catch {
        this.$root.$emit("display-alert", {
          text: this.$t("sidebar.languageSaveFailed"),
          type: 1,
        });
      }
    },
  },
};
</script>

<style scoped>
.lang-flag {
  border-radius: 50%;
}
</style>
